import { IClientComponentDefinition } from '@glidecms/deliver-core-dev/gd-module'

export const WArticleTaxonomiesCCD: IClientComponentDefinition = {
  name: 'WArticleTaxonomies',
  load: () =>
    import(/* webpackChunkName: 'WArticleTaxonomies' */ './w-article-taxonomies.component'),
}
